import axios from 'axios';

export const trackShare = async (payload: { platform: string; email?: string }) => {
    try {
        return await axios.post('/api/invite/share', payload);
    } catch (e) {
        console.error('trackShare error', e);
        return null;
    }
};

